import { publicKey } from '../services/components/public_key.jsx'

function getState(publicKey, keyRecieved) {
    localStorage.setItem("public", JSON.stringify(publicKey))
    return {
        type: "PUBLIC_KEY",
        publicKey,
        keyRecieved
    }
}

export const publicKeyAction = (keyRecieved) => dispatch => {
    let state = [];
    let display = keyRecieved;
    publicKey((data, msg) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch(getState(state, display))
    })
}


// WEBPACK FOOTER //
// ./src/actions/public_key.jsx